module.exports = __webpack_public_path__ + "static/media/cahsback-banner.660e13da.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/banners/landing-cashback/cahsback-banner.png
// module id = 422
// module chunks = 14